import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { Card, Typography, Row, Col, Spin, Button } from 'antd';
import { QRCodeSVG } from 'qrcode.react';

const { Title, Text } = Typography;

function Qrcode() {
  const [assetData, setAssetData] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const qrRef = useRef(null);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const assetId = searchParams.get('asset_id');

    if (!assetId) {
      setLoading(false);
      return;
    }

    fetch('/cardData.json')
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        const asset = data.find((item) => item.assetId === assetId);
        setAssetData(asset || null);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        setLoading(false);
      });
  }, [location]);

  const downloadQRCode = () => {
    const svg = qrRef.current.querySelector('svg');
    const serializer = new XMLSerializer();
    const svgData = serializer.serializeToString(svg);
    const canvas = document.createElement('canvas');
    const img = new Image();

    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      const pngFile = canvas.toDataURL('image/png');
      const downloadLink = document.createElement('a');
      downloadLink.href = pngFile;
      downloadLink.download = 'asset-qrcode.png';
      downloadLink.click();
    };

    img.src = 'data:image/svg+xml;base64,' + btoa(svgData);
  };

  if (loading) {
    return (
      <div style={{ padding: '40px', textAlign: 'center' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!assetData) {
    return (
      <div style={{ padding: '40px', textAlign: 'center' }}>
        <Text type="danger">Asset not found</Text>
      </div>
    );
  }

  return (
    <div style={{ padding: '24px', maxWidth: 800, margin: '0 auto' }}>
      <Card bordered={false} style={{ boxShadow: '0 4px 12px rgba(0,0,0,0.1)', borderRadius: '12px' }}>
        <Row justify="space-between" align="middle" gutter={[16, 16]} style={{ marginBottom: '24px' }}>
          <Col>
            <Title level={3} style={{ margin: 0 }}>Asset QR Code</Title>
          </Col>
          <Col style={{ textAlign: 'center' }}>
            <div ref={qrRef}>
              <QRCodeSVG value={window.location.href} size={120} />
            </div>
            <Button onClick={downloadQRCode} type="primary" size="small" style={{ marginTop: '10px' }}>
              Download QR Code
            </Button>
          </Col>
        </Row>

        <Row gutter={[16, 16]}>
          {[
            ['Asset ID', assetData.assetId],
            ['Asset Code', assetData.assetCode],
            ['Name', assetData.name],
            ['Assigned To', assetData.assignTo || 'Not Assigned'],
            ['Handover Date', assetData.handoverDate],
            ['Received', assetData.received],
            ['Invoice No', assetData.invoiceNo],
            ['Price', assetData.price],
            ['Brand', assetData.brand],
            ['Who Assigned', assetData.whoAssigned],
          ].map(([label, value], index) => (
            <Col xs={24} sm={12} key={index}>
              <Text strong>{label}: </Text>
              <Text>{value || 'N/A'}</Text>
            </Col>
          ))}
        </Row>
      </Card>
    </div>
  );
}

export default Qrcode;
